import { axios } from "./axiosSettings";
import { getAuthToken } from "../helpers/session.js";
import { JRCS_ID } from "../constants/jrcsID"

export const fetchVesselApplication = async (companyId) => {
  if (companyId === JRCS_ID) companyId = null;
  try {
    const { data } = await axios.get(`/vesselApplication/vessel`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
      params: {
        manager_id: companyId,
      },
    });
    return data;
  } catch (e) {
    return { vesselApplication: e };
  }
};

export const fetchVesselApplicationByVesselId = async (vesselId, addonId) => {
  try {
    const { data } = await axios.get(`/vesselApplication/vessel`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
      params: {
        vessel_id: vesselId,
        addon_id: addonId,
      },
    });
    return data;
  } catch (e) {
    return { vesselApplication: e };
  }
};

export const fetchAddon = async (addonName) => {
  try {
    const { data } = await axios.get(`/addon`, {
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
      params: {
        name: addonName,
      },
    });
    return data;
  } catch (e) {
    return { addon: e };
  }
};
